import * as t from 'io-ts';

import {mergeTimestamps} from '../helpers/merge';

/*
 * Runtime types.
 */

export const RDismissedProductUpdates = t.record(t.string, t.number);

/*
 * Constants.
 */

export const defaultDismissedProductUpdates = {};

/*
 * Helpers.
 */

export function calculateDismissedProductUpdateKey(link: string, timestamp: number): string {
  return `${timestamp}:${link}`;
}

/*
 * Merge strategy.
 */

export function mergeDismissedProductUpdates(
  left: Record<string, number>,
  right: Record<string, number>,
): Record<string, number> {
  return mergeTimestamps(left, right);
}
